import { FC, PropsWithChildren, useMemo } from 'react';
import { create } from 'zustand';
import { PreferenceContext, PreferenceInfo } from './useLocalPreferences';

export const PreferenceProvider: FC<PropsWithChildren> = ({ children }) => {
  const store = useMemo(
    () =>
      create<PreferenceInfo>(set => ({
        bbbMode: localStorage.getItem('bbbMode') === 'true',
        regionIdToView: localStorage.getItem('regionIdFilter') || '',
        setBbbMode: (bbbMode: boolean) => {
          set({ bbbMode });
          localStorage.setItem('bbbMode', bbbMode.toString());
        },
        setRegionIdToView: (newId?: string) => {
          set({ regionIdToView: newId });
          localStorage.setItem('regionIdFilter', newId || '');
        }
      })),
    []
  );

  return <PreferenceContext.Provider value={store}>{children}</PreferenceContext.Provider>;
};
